module.exports = __webpack_public_path__ + "img/ds-logo.15042a1.svg";